import { render, staticRenderFns } from "./AbrirChamado.vue?vue&type=template&id=27232bfa"
import script from "./AbrirChamado.vue?vue&type=script&lang=js"
export * from "./AbrirChamado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports